/**
 * @fileoverview POST handler for the "/engagement/expressive_reports/:report_id/archive" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { archiveQueryBuilderReportCacheKeys } from "./constants";
import type { ArchiveQueryBuilderReportProps, ArchiveQueryBuilderReportResult } from "./types";

export const archiveQueryBuilderReport = reactQueryMutationAdapter(
  archiveQueryBuilderReportCacheKeys,
  (props: ArchiveQueryBuilderReportProps): Promise<ArchiveQueryBuilderReportResult> => {
    return fetch(`/engagement/expressive_reports/${props.reportId}/archive`, "POST", props);
  }
);
